import React, { createContext, useContext, useState } from 'react';

interface ILoadingContextProps {
  isLoading: boolean;
  showLoading: () => void;
  hideLoading: () => void;
}

export const LoadingContext = createContext<ILoadingContextProps | undefined>(undefined);

interface ILoadingProviderProps {
  children: React.ReactNode;
}

export const LoadingProvider = ({ children }: ILoadingProviderProps) => {
  const [isLoading, setLoading] = useState<boolean | false>(false);

  const showLoading = () => {
    setLoading(true);
  }

  const hideLoading = () => {
    setLoading(false);
  }

  return (
    <LoadingContext.Provider value={{ isLoading, showLoading, hideLoading }}>
      {children}
    </LoadingContext.Provider>
  )
}

export const useLoading = () => {
  const context = useContext(LoadingContext);
  if (!context) {
    throw new Error("useLoading must be used within a LoadingProvider");
  }

  return context;
}